import { ApplicationInsights, DistributedTracingModes } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import APPINSIGHTS_CONNECTION_STRING from "../configs/appInsightConfig";

const reactPlugin: ReactPlugin = new ReactPlugin();

const appInsights: ApplicationInsights = new ApplicationInsights({
	config: {
		connectionString: APPINSIGHTS_CONNECTION_STRING,
		extensions: [reactPlugin],
		// Don't enable this if we use `history` in the router.
		// https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript-framework-extensions?tabs=react#track-router-history
		enableAutoRouteTracking: true,

		// We want to sent "Request-Id" in our headers for open telemetry to work.
		distributedTracingMode: DistributedTracingModes.AI_AND_W3C,

		// this is not automatically enabled in version less than 2.8
		// https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript-sdk-configuration
		disableFetchTracking: false,

		// See https://github.com/microsoft/ApplicationInsights-JS/issues/1229#issuecomment-607439162
		// 'By Default these headers will only be include if the current window hostname is the same as the API endpoint.'
		enableCorsCorrelation: true,
		correlationHeaderDomains: [
			"receivinguiuat.z26.web.core.windows.net",
			"receivinguidev.z26.web.core.windows.net",
			"receivinguiprod.z26.web.core.windows.net",
			"localhost",
		],
	},
});
appInsights.loadAppInsights();
export { reactPlugin, appInsights };
